/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MemberStats } from './memberStats';
import { ScanWindow } from './scanWindow';
import { ErrorCount } from './errorCount';
import { CompanyStats } from './companyStats';


export interface AdminPlatformStatsDto { 
    companies?: CompanyStats;
    members?: MemberStats;
    scansToday?: ScanWindow;
    scansLast7Days?: ScanWindow;
    scanErrorsLast7Days?: Array<ErrorCount>;
    couponsRedeemedLast7Days?: number;
}

